import { render, staticRenderFns } from "./PrePostEdit.vue?vue&type=template&id=711df61e"
import script from "./PrePostEdit.vue?vue&type=script&lang=js"
export * from "./PrePostEdit.vue?vue&type=script&lang=js"
import style0 from "./PrePostEdit.vue?vue&type=style&index=0&id=711df61e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports